import React from "react";
import "./CardTitle.css";

function CardTitle({ children }: { children: React.ReactNode }) {
  return <p className="count-card-title-text">{children}</p>;
}

export default CardTitle;
